import styles from './TechStack.module.scss';
import { techStack } from '../../data/resume';

export function TechStack() {
  return (
    <section className="section container" id="tech" aria-label="Tech Stack">
      <h2 className="sectionTitle">Tech Stack</h2>
      <div className={styles.wrapper}>
        {techStack.map(group => (
          <div key={group.title} className={styles.group}>
            <h3 className={styles.groupTitle}>{group.title}</h3>
            <div className={styles.items}>
              {group.items.map(item => (
                <span key={item} className={`badge`}>{item}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}